import Swiper from "~/components/categorySwiper/Swiper/index";
import { TitleIcon } from "~/loaders/TitleIcon";
import type { HTMLWidget, ImageWidget } from "~/types/widgets";
import Image from "~/components/ui/Image";
import { type FnContext as FnContext, type SectionProps as SectionProps } from "~/types/deco";
interface IconType {
    /**
     * @title Texto alternativo
     */
    alt: string;
    /**
     * @title Ícone
     */
    src: ImageWidget;
}
interface ImageType {
    /**
     * @title Texto alternativo
     */
    alt?: string;
    /**
     * @title Imagem
     */
    src: ImageWidget;
}
interface Banner {
    /**
     * @title Imagem
     */
    image: ImageType;
    /**
     * @title Title
     * @description Título da seção
     */
    title: HTMLWidget;
    /**
     * @title Ícones em volta do título
     */
    titleIcon?: TitleIcon;
}
/**
 * @titleBy href
 */
export interface Item {
    /**
     * @title Link
     */
    href: string;
    /**
     * @title Ícone
     */
    icon: IconType;
}
export interface Props {
    /**
     * @title Banner
     */
    banner: Banner;
    /**
     * @title Itens
     */
    items: Item[];
}
const CategorySwiper = ({ banner, items = [], isMobile }: SectionProps<typeof loader>) => {
    return (<div data-prerender className='flex flex-col gap-9 mx-auto py-6 lg:py-12 w-full'>
            <div className='bg-black h-[5.3125rem] relative w-full'>
                <div className='flex items-center justify-center gap-8 h-full mx-auto px-4 absolute [&_svg]:text-[#ffffff] w-full'>
                    {banner.titleIcon && (<Image src={banner.titleIcon.icon} alt={banner.titleIcon.alt} width={banner.titleIcon.width} height={banner.titleIcon.height} loading='lazy'/>)}

                    {banner.title && (<div className='font-light leading-normal text-[#ffffff] text-center text-base lg:text-4xl uppercase [&_strong]:text-[#ffffff] [&_strong]:text-base [&_strong]:lg:text-4xl [&_strong]:font-bold' dangerouslySetInnerHTML={{ __html: banner.title }}/>)}

                    {banner.titleIcon && (<Image src={banner.titleIcon.icon} alt={banner.titleIcon.alt} width={banner.titleIcon.width} height={banner.titleIcon.height} loading='lazy'/>)}
                </div>

                <Image alt={banner.image.alt ?? ''} className='h-full mx-auto max-w-[1730px] object-cover w-full' height={85} src={banner.image.src} width={1920} loading='lazy'/>
            </div>

            {isMobile ? <Swiper items={items}/> : (<div className='py-2 grid gap-4 justify-items-center justify-center content-start px-4 w-full max-w-[1730px] mx-auto' style={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}>
                    {items.map((item) => (<a className='aspect-square bg-black duration-200 ease-in-out flex flex-shrink-0 h-full max-h-[9.6875rem] hover:bg-[#e5554f] [&_img]:hover:grayscale-[100%] items-center justify-center rounded-full transition-all w-full max-w-[9.6875rem]' title={item.icon.alt} href={item.href}>
                            <Image alt={item.icon.alt} className='h-[55%] object-contain w-[55%]' height={80} src={item.icon.src} width={80} loading='lazy'/>
                        </a>))}
                </div>)}
        </div>);
};
export const loader = (props: Props, _: Request, ctx: FnContext) => {
    return { ...props, isMobile: ctx.device !== 'desktop' };
};
export default CategorySwiper;
